import { useCallback } from 'react';

import type { BanditVariant } from 'src/app/pages/psf/share/shared/types';

import { useHeadlineBanditVariants } from './variants';

type Result = (channel: 'facebook' | 'whatsapp' | 'copy' | 'twitter') => BanditVariant | undefined;

export function useGetHeadlineVariant(): Result {
	const variants = useHeadlineBanditVariants();

	return useCallback((channel) => variants[channel], [variants]);
}
